var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-cropper-container" },
    [
      _c("pop-up-images", {
        ref: "popUpImages",
        on: {
          selectedGalleryImage: _vm.imageSelectedGallery,
          uploadCustomThumbnail: _vm.uploadThumbnail,
          uploadHero: _vm.uploadHero,
          upload2x3: _vm.upload2x3
        }
      }),
      _vm._v(" "),
      _vm.isAlertVisible
        ? _c("div", { staticClass: "help-alert" }, [
            _c("p", [
              _vm._v(
                "When using the hero image on Roku, please be aware that there will be an overlay box covering a portion. Ensure important logos or text in the hero image are not obstructed. Here's an approximate example for reference:"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image-container" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.baseUrl + _vm.imageTooltip, alt: "" }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition-group", { attrs: { name: "image-slider" } }, [
        _c("div", { key: 1, staticClass: "compressed-images" }, [
          _c("div", { staticClass: "img-copped-container" }, [
            _c("div", { staticClass: "image-section" }, [
              _c("div", { staticClass: "aspect-ratio-selection" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.aspectRatio,
                      expression: "aspectRatio"
                    }
                  ],
                  staticClass: "input-radio",
                  attrs: { type: "radio", value: "16/9" },
                  domProps: { checked: _vm._q(_vm.aspectRatio, "16/9") },
                  on: {
                    change: function($event) {
                      _vm.aspectRatio = "16/9"
                    }
                  }
                }),
                _vm._v(" Thumbnail (16x9)\n                    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cropped-images",
                  attrs: { id: "add-thumbnail-image" },
                  on: {
                    click: function($event) {
                      return _vm.popUpImagesOpen("custom")
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cropped-image",
                      class: { selected: _vm.aspectRatio === "16/9" },
                      on: {
                        click: function($event) {
                          return _vm.changeAspectRatio("16/9")
                        }
                      }
                    },
                    [
                      _vm.shouldDisplayVideoImage()
                        ? _c("img", { attrs: { src: _vm.getElementImage() } })
                        : _vm.shouldDisplaySerieImage()
                        ? _c("img", { attrs: { src: _vm.getElementImage() } })
                        : _vm.shouldDisplayDistributionImage()
                        ? _c("img", { attrs: { src: _vm.getElementImage() } })
                        : _c("i", { staticClass: "fa fa-plus icon-card" })
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image-section" }, [
              _c("div", { staticClass: "aspect-ratio-selection hero-card" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.aspectRatio,
                      expression: "aspectRatio"
                    }
                  ],
                  staticClass: "input-radio",
                  attrs: { type: "radio", value: "9/4" },
                  domProps: { checked: _vm._q(_vm.aspectRatio, "9/4") },
                  on: {
                    change: function($event) {
                      _vm.aspectRatio = "9/4"
                    }
                  }
                }),
                _vm._v(" Hero (9x4)\n                        "),
                _c(
                  "div",
                  {
                    staticClass: "help-icon",
                    on: {
                      mouseover: _vm.showInstructions,
                      mouseout: _vm.hideInstructions
                    }
                  },
                  [_c("i", { staticClass: "fa fa-info-circle" })]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cropped-images",
                  attrs: { id: "add-hero-image" },
                  on: {
                    click: function($event) {
                      return _vm.popUpImagesOpen("heroimage")
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cropped-image",
                      class: { selected: _vm.aspectRatio === "9/4" },
                      on: {
                        click: function($event) {
                          return _vm.changeAspectRatio("9/4")
                        }
                      }
                    },
                    [
                      (_vm.mediaItem.heroImage !== "false" &&
                        _vm.mediaItem.heroImage) ||
                      _vm.heroImage ||
                      _vm.heroImageGallery
                        ? _c("div", { staticClass: "image-container" }, [
                            _c("div", { staticClass: "image-overlay" }),
                            _vm._v(" "),
                            (_vm.mediaItem.heroImage !== "false" &&
                              _vm.mediaItem.heroImage) ||
                            _vm.heroImage
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.heroImage
                                      ? _vm.heroImage
                                      : _vm.heroImageGallery
                                      ? _vm.baseUrl + _vm.heroImageGallery
                                      : _vm.baseUrl + _vm.mediaItem.heroImage,
                                    alt: "Cropped Image 9x4"
                                  }
                                })
                              : _vm._e()
                          ])
                        : _c("i", { staticClass: "fa fa-plus icon-card" })
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            !_vm.isDistribution
              ? _c("div", { staticClass: "image-section" }, [
                  _c("div", { staticClass: "aspect-ratio-selection" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.aspectRatio,
                          expression: "aspectRatio"
                        }
                      ],
                      staticClass: "input-radio",
                      attrs: { type: "radio", value: "2/3" },
                      domProps: { checked: _vm._q(_vm.aspectRatio, "2/3") },
                      on: {
                        change: function($event) {
                          _vm.aspectRatio = "2/3"
                        }
                      }
                    }),
                    _vm._v(" Poster (2x3)\n                    ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cropped-images",
                      attrs: { id: "add-2x3-image" },
                      on: {
                        click: function($event) {
                          return _vm.popUpImagesOpen("thumbnail2x3")
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cropped-image container-2x3",
                          class: { selected: _vm.aspectRatio === "2/3" },
                          on: {
                            click: function($event) {
                              return _vm.changeAspectRatio("2/3")
                            }
                          }
                        },
                        [
                          _vm.mediaItem.thumbnail2x3 ||
                          _vm.thumbnail2x3 ||
                          _vm.thumbnail2x3Gallery
                            ? _c("img", {
                                attrs: {
                                  src: _vm.thumbnail2x3
                                    ? _vm.thumbnail2x3
                                    : _vm.thumbnail2x3Gallery
                                    ? _vm.baseUrl + _vm.thumbnail2x3Gallery
                                    : _vm.baseUrl + _vm.mediaItem.thumbnail2x3,
                                  alt: "Cropped Image 2x3"
                                }
                              })
                            : _c("i", { staticClass: "fa fa-plus icon-card" })
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-overlay-help" }, [
      _c("p", [_vm._v("Video name")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fa2d5e7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa2d5e7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/upload/ImageUploadCroped.vue
// module id = 808
// module chunks = 0